import type { Direction, PickerSlot } from "../../api/contract";
import { DrillCoverageHint } from "./drill-coverage-hint";
import { Card, CardContent } from "@bindery/ui/components/ui/card";

interface DrillPickerProps {
  slots: PickerSlot[];
  direction: Direction;
  onSelect: (slot: PickerSlot) => void;
}

export function DrillPicker({ slots, direction, onSelect }: DrillPickerProps) {
  // Ensure we always show exactly 3 slot positions
  const displaySlots = [slots[0] ?? null, slots[1] ?? null, slots[2] ?? null];

  return (
    <div className="flex flex-col gap-3">
      <p className="text-muted-foreground text-sm">
        {direction === "ja_to_en"
          ? "Pick a sentence to translate to English:"
          : "Pick a sentence to translate to Japanese:"}
      </p>
      <div className="grid gap-3">
        {displaySlots.map((slot, i) => (
          <Card
            key={i}
            className={
              slot
                ? "hover:bg-accent/50 cursor-pointer transition-colors"
                : "pointer-events-none opacity-40"
            }
            onClick={() => slot && onSelect(slot)}
          >
            <CardContent className="p-4">
              {slot ? (
                <div className="flex flex-col gap-2">
                  <p className="text-base leading-relaxed">
                    {direction === "ja_to_en"
                      ? slot.candidate.text
                      : (slot.translation ?? slot.candidate.text)}
                  </p>
                  <div className="flex items-center gap-2">
                    <DrillCoverageHint
                      unknownCount={slot.candidate.unknown_lemma_count}
                    />
                    <span className="text-muted-foreground text-xs">
                      @{slot.candidate.post_author_handle}
                    </span>
                  </div>
                </div>
              ) : (
                <p className="text-muted-foreground text-sm italic">
                  No cached translation available
                </p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
